import { trpc } from '@/shared/api';

interface InvalidateProducts {
  readonly list: () => void;
  readonly detail: (id: string) => void;
}

/** 상품 캐시 무효화 — 목록·상세 invalidation 을 한곳에 모은다. */
export const useInvalidateProducts = (): InvalidateProducts => {
  const utils = trpc.useUtils();

  return {
    list: () => void utils.productManagement.products.list.invalidate(),
    detail: (id) => void utils.productManagement.products.get.invalidate({ id }),
  };
};
